import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TooltipModule } from '../../directives/tooltip/tooltip.module';
import { KpiComponent } from './kpi.component';

@NgModule({
  declarations: [KpiComponent],
  imports: [CommonModule, TooltipModule],
  exports: [KpiComponent]
})
export class KpiModule { }
